/**
 * Complete Task manifest — `complete-task` action.
 *
 * Same-entity action: primaryEntity and requires.entity are both "task", so
 * the walker resolves a zero-hop path (source === target) and runs the
 * server handler directly against the task the user is looking at. Closes
 * part of the iOS global-search catalog gap (issue #2534) — `task` had no
 * entries in `HUB_ACTION_CATALOG`, so `HubActions.forEntity(.task)` returned
 * an empty menu.
 *
 * `mode: "server"` because the handler mutates `contact_tasks` via the
 * service-role client (reusing `markTaskCompleteFromSlack`) — see
 * `lib/actions/handlers/completeTask.ts` for the ownership guard that keeps
 * this from completing a task the caller doesn't own.
 */

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "complete-task",
  label: "Complete",
  primaryEntity: "task",
  requires: {
    entity: "task",
    requiredFields: [],
  },
  mode: "server",
});
